<template>
  <div class="parent-box">
    <modal-main v-if="showEdit" @close="showEdit = false">
      <h4 slot="header">
        Edit Payment Schedule
      </h4>
      <div slot="body" style="width: 100%;">
        <form  style="width: 100%;">
          <div class="form-group">
            <label for="exampleInputEmail1">Customer ID</label>
            <input
              type="email"
              class="form-control"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
            />
           
          </div>
          <div class="form-group">
            <label for="exampleInputPassword1">New Amount</label>
            <input
              type="password"
              class="form-control"
              id="exampleInputPassword1"
            />
          </div>
        </form>
        <div class="pt-4 text-right">
          <button
            type="button"
            @click="showModal = true"
            class="btn btn-warning btn-sm"
          >
            Submit
          </button>
        </div>
      </div>
    </modal-main>
    <!-- step 1 -->
    <div class="container">
      <h2 class="page-header">Payment Schedule</h2>
    </div>

    <table class="table table-bordered">
      <br />

      <tr>
        <th class="text-nowrap mr-5">Transaction Type</th>
        <th class="text-nowrap mr-5 go-right text-left pr-5">
          Transaction Reference
        </th>
        <th class="text-nowrap mr-5 go-righty text-left">Payment Amount</th>
        <th class="text-nowrap">Actual Amount</th>
        <th class="text-nowrap">Transaction Status</th>
        <th class="text-nowrap">Actions</th>
      </tr>
      <tr v-for="item in datas" :key="item.id">
        <td class="mr-5 text-nowrap text-center">
          {{ item.transactionType }}
        </td>
        <td class="mr-5 text-nowrap text-center">
          {{ item.transactionReference }}
        </td>
        <td class="mr-5 text-nowrap text-center">{{ item.paymentAmount }}</td>
        <td class="mr-5 text-nowrap text-center">{{ item.actualAmount }}</td>
        <td class="mr-5 text-nowrap">{{ item.status }}</td>
        <td><span class="btn text-success" @click="edit">Edit Payment Schedule</span></td>
      </tr>
    </table>

    <div class="footer">
      <!-- real footer item -->
    </div>
  </div>
</template>

<script>
/* eslint-disable */
// import { mapGetters, mapActions } from "vuex";
import axios from "axios";
import ModalMain from './Modal';

export default {
  name: "FinishTab",
  props: {
    getUserSession: null,
  },
  components: {
      ModalMain
  },
  computed: {},
  data() {
    return {
      form: {
        bvn: "",
      },
      showEdit: false,
      formErrors: {},
      datas: [],
      datar: [],
      show1: true,
      show2: false,
      // activeIndex: 0,
      summary: {},
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!",
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!",
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!",
    },
  },
  methods: {
    gotoNextState() {
      // this.$emit("updateStatus");
    },
    showFirst() {
      this.show1 = true;
      this.show2 = false;
    },

    showSecond() {
      (this.show1 = false), (this.show2 = true);
    },
    getCustomers() {
      axios
        .get(
          `https://solarbase-test-env-dev.us-west-2.elasticbeanstalk.com/api/v1/transactionHistories`
        )
        .then((res) => {
          this.datas = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    edit() {
    console.log('edit')
      this.showEdit = true;
    },
    getThis() {
      axios
        .get(
          `https://solarbase-test-env-dev.us-west-2.elasticbeanstalk.com/api/v1/recurringPaymentSetups`
        )
        .then((res) => {
          this.datar = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  async mounted() {
    this.getCustomers();
    this.getThis();
  },
};
</script>

<style lang="scss" scoped>
.tray-show {
  background-color: #000;
  color: white;
  border: 1px solid #000;
  height: 5rem;
  padding: 10px 0px;
  width: 100%;
}

.active-link {
  color: #ffb946;
  margin-left: 1rem;
}

.right-space {
  padding-right: 10rem;
}

.cursor {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/customer-admin/PaymentSchedule.vue